import apiService from './api'
import type {
  NavigationAuditLogPage,
  NavigationBulkUpdatePayload,
  NavigationItem,
} from '@/types/navigation'

class NavigationService {
  private readonly navigationEndpoint = '/navigation'
  private readonly adminNavigationEndpoint = '/admin/navigation'

  async fetchNavigation(): Promise<{ items: NavigationItem[] }> {
    return await apiService.get<{ items: NavigationItem[] }>(this.navigationEndpoint)
  }

  async fetchAdminNavigation(): Promise<{ items: NavigationItem[] }> {
    return await apiService.get<{ items: NavigationItem[] }>(this.adminNavigationEndpoint)
  }

  async saveNavigation(
    payload: NavigationBulkUpdatePayload
  ): Promise<{ items: NavigationItem[]; message: string }> {
    return await apiService.put<{ items: NavigationItem[]; message: string }>(
      this.adminNavigationEndpoint,
      payload
    )
  }

  async fetchAudit(page = 1): Promise<NavigationAuditLogPage> {
    return await apiService.get<NavigationAuditLogPage>(
      `${this.adminNavigationEndpoint}/audit`,
      { params: { page } }
    )
  }
}

export const navigationService = new NavigationService()
